namespace Nobox.Pages {
    export namespace AgentOnlineServiceService {
        export const baseUrl = 'AgentOnlineService';


        export declare const enum Methods {

        }

    }
}
